import React from "react";
import { Anchor, Text } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";

export default function NotificationLink({ href, text, notificationId }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (notificationId) {
      notifications.hide(notificationId);
      navigate(href);
    }
  };

  return (
    <Anchor size="sm" onClick={handleClick}>
      {text}
    </Anchor>
  );
}
